import { track } from './core';
import { trackingEventNames } from '../../settings/constants';

import ISignUpFormType from './interfaces/ISignUpFormType';
import ISignUpFormInteraction from './interfaces/ISignUpFormInteraction';

export function track_hcp_signup_begin(version: ISignUpFormType) {
	const event = {
		event: trackingEventNames.HCP_SIGNUP_BEGIN,
		signup_version: version,
	}
	track(event);
}

export function track_hcp_signup_step(signup_interaction: ISignUpFormInteraction, version: ISignUpFormType) {
	const event = {
		event: trackingEventNames.HCP_SIGNUP_STEP,
		signup_interaction: signup_interaction,
		signup_version: version,

	}
	track(event);
}

export function track_hcp_signup_completed(version: ISignUpFormType) {
	const event = {
		event: trackingEventNames.HCP_SIGNUP_COMPLETED,
		signup_version: version,
	}
	track(event);
}

export function track_profile_completed() {
	const event = {
		event: trackingEventNames.PROFILE_COMPLETED,
	}
	track(event);
}

export function track_form_submission(formName: string) {
	const event = {
		event: trackingEventNames.FORM_SUBMISSION,
		submitted_form: formName,
	}
	track(event);
}

export function track_dual_checkout_choice(choice: string) {
	const event = {
		event: trackingEventNames.DUAL_CHECKOUT_CHOICE,
		consumer_or_hcp: choice,
	}
	track(event);
}